var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 17,
  viewBox: "0 0 21 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3085_5267)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.39941 7.68359L19.3994 7.68359C19.9494 7.68359 20.3994 8.13359 20.3994 8.68359C20.3994 9.23359 19.9494 9.68359 19.3994 9.68359L1.39941 9.68359C0.849415 9.68359 0.399414 9.23359 0.399414 8.68359C0.399414 8.13359 0.849415 7.68359 1.39941 7.68359Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.39985 0.683769C8.65985 0.683769 8.90985 0.78377 9.10985 0.973769C9.49985 1.36377 9.49985 1.99377 9.10985 2.38377L2.81984 8.67377L9.10984 14.9738C9.49984 15.3638 9.49984 15.9938 9.10984 16.3838C8.71984 16.7738 8.08984 16.7738 7.69984 16.3838L0.699844 9.38377C0.309844 8.99377 0.309844 8.36377 0.699844 7.97377L7.69985 0.973769C7.89985 0.773769 8.14985 0.683769 8.40985 0.683769L8.39985 0.683769Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3085_5267"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 16,
  transform: "translate(20.3994 16.6836) rotate(-180)"
})))));
export default SvgIconArrowLeft;